import React, { useState, useMemo } from "react";

import { ReactFlowProvider } from "react-flow-renderer";

import { PageLoader, Typography } from "clearsense-ui/components";
import useJobResultData from "hooks/useJobResultData";

import { getGraph } from "./data";

import Graph from "../Graph";

const RelationshipGraph = ({ isLoading, jobDetails, outputs, setOutputs }) => {
  const [selectedNode, setSelectedNode] = useState();

  const { data: relationshipGraph, loading: relationshipGraphLoading } =
    useJobResultData(outputs, setOutputs, "model_relationship_graphs");

  const initialGraphSchema = useMemo(
    () =>
      jobDetails &&
      relationshipGraph &&
      getGraph(jobDetails, relationshipGraph.target_relationship_graph),
    [jobDetails, relationshipGraph]
  );

  if (isLoading || relationshipGraphLoading) {
    return <PageLoader />;
  } else if (!initialGraphSchema) {
    return (
      <div className="min-h-[400px] flex justify-center items-center">
        <Typography>Failed to Load data</Typography>
      </div>
    );
  }

  return (
    <ReactFlowProvider>
      <Graph {...initialGraphSchema} setSelectedNode={setSelectedNode} />
      <div node={selectedNode}></div>
    </ReactFlowProvider>
  );
};

export default RelationshipGraph;
